// extracted by mini-css-extract-plugin
module.exports = {"backgroud":"password-reset_backgroud__3gdER","padding":"password-reset_padding__130yt"};